import React, { useEffect, useRef } from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
// import gsap from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger";
//
// gsap.registerPlugin(ScrollTrigger);

const TitleContent = ({title, h1, richContent, firstBlockOnPage}) => {
  // const elementRef = useRef(null)
  //
  // useEffect(() => {
  //   const line = elementRef.current?.querySelector('.line');
  //
  //   ScrollTrigger.create({
  //     trigger: elementRef.current,
  //     start: "top bottom",
  //     onEnter: () => {
  //       line.classList.add('is-inview')
  //     },
  //   });
  //
  //   return () => {
  //     ScrollTrigger.kill();
  //   };
  // }, []);

  return (
    <section className={`title-content${firstBlockOnPage ? ' title-content--first' : ''}`}>
      <div className="title-content__inner">
        <div className="title-content__wrapper">
          <div className="line line--vertical center-top"></div>

          <div className="title-content__title">
            {title && h1 && <h1>{parse(title)}</h1>}
            {title && !h1 && <h2>{parse(title)}</h2>}
          </div>

          <div className="title-content__content">
            {richContent && <StructuredText data={richContent} />}
          </div>
        </div>
      </div>
    </section>
  )
}

export default TitleContent

export const query = graphql`
  fragment TitleContentProps on DatoCmsTitleContent {
    ... on DatoCmsTitleContent {
      id
      title
      h1
      richContent {
        value
      }
      firstBlockOnPage
    }
  }
`